import apiClient from '../config/axiosConfig';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getStudioCConfiguration() {
    return function (dispatch) {
        dispatch({
            type: types.GET_STUDIOC_CONFIGURATION_MODULES_PENDING,
        });
        return apiClient.get('/v5/studio-c/configuration')
            .then((response) => {
                dispatch({
                    type: types.GET_STUDIOC_CONFIGURATION_MODULES_SUCCESS,
                    payload: response.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_STUDIOC_CONFIGURATION_MODULES_FAILED);
            });
    };
}